/**
 * Promise that resolves once the paywall has been displayed.
 * Includes a timeout safeguard (30s here, tweak as needed).
 */
const waitForPaywall = new Promise( ( resolve, reject ) => {
	const timeout = setTimeout( () => reject( new Error( 'Paywall event timed out' ) ), 30000 );
	window.addEventListener( 'payWallDisplayed', () => {
		clearTimeout( timeout );
		resolve();
	}, { once: true } );
} );

/**
 * Main async function wrapping all the logic
 */
( async () => {
	try {
		// Wait for both RTA readiness AND paywall display
		await Promise.all( [ waitForPaywall ] );

		// Report paywall status once both conditions are met
		RTA.updateReport( { paywallStatus: 'isPaywalled' } );
	} catch ( err ) {
		// RTA Paywall reporting failed
	}
} )();

/**
 * Since we have a dependancy on the enqueue script we can assume that the RTA script is loaded
 */

// Dispatch a custom event for anything else listening
window.dispatchEvent( new CustomEvent( 'rtaScriptLoaded' ) );

if ( 'RTA' in window ) {
	let userStatus = window.userState;

	if ( userStatus === 'no-auth' ) {
		userStatus = 'none';
	}

	window.RTA.updateReport( {
		userStatus,
	} );
}

// Handle paywall conversion transaction tracking
const params = new URLSearchParams( document.location.search );
const urlRtaId = params.get( 'rtaId' );

const sessionRtaId = sessionStorage.getItem( 'rtaId' );
const localRtaId = localStorage.getItem( 'rtaId' );

/**
 * If there is no existing local storage data and the URL parameter exists check for the RTA user id
 * and see if it matches the url. If so then send the paywall conversion and set session storage.
 * If they aren't the same then send a false conversion as it means the URL could have been shared.
 *
 * I am also checking against session storage for users who were using the previous method of using
 * session storage.
 */
if ( ! localRtaId && ! sessionRtaId && urlRtaId ) {
	( async () => {
		try {
			// Wait for both RTA readiness AND paywall display
			const rtaId = ( await RTA.ids ).user;
			if ( Number( urlRtaId ) === rtaId ) {
				if ( 'RTA' in window ) {
					RTA.deferred( 'paywall', [ { pageEvents: { paywall_conversion: 1 } } ] );
				}
				localStorage.setItem( 'rtaId', rtaId );
			} else if ( 'RTA' in window ) {
				RTA.pageEvent( { paywall_false_conversion: 'mismatch' } );
			}
		} catch ( err ) {
			console.error( 'RTA user id didn\'t load:', err );
		}
	} )();
}
